import React, { FC } from 'react'
import Modal from 'react-modal'
import classNames from 'classnames'
import { ChasingDots } from 'styled-spinkit'

import { ModalContent, ModalFooter, ModalFooterButton, ModalHeader, modalStyle } from './styles'
import { useAppTheme } from '../../defaultTheme'

type Props = {
  onClose?(): void
}

// Render this instead of SettingsPopup when contents are not ready
export const LoadingSettingsPopup: FC<Props> = ({ onClose }) => {
  const theme = useAppTheme()

  return (
    <Modal
      isOpen={true}
      style={modalStyle}
      onRequestClose={onClose}
      className={classNames('e2e-botsettings-modal modal-default')}
    >
      <ModalHeader></ModalHeader>
      <ModalContent>
        <ChasingDots color={theme?.loading} />
      </ModalContent>
      <ModalFooter>
        <ModalFooterButton label="Close" className="e2e-close-bot-modal-button" onClick={onClose} />
      </ModalFooter>
    </Modal>
  )
}

export type SettingsPopupWithLoaderProps = Props
